module.exports = __webpack_public_path__ + "static/2-d3065c93a2e38f0fba65da69927e480c.jpg";